// Add your custom JS here.
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

// Word Wheel
document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.word-wheel-swiper', {
        direction: 'vertical',
        loop: true,
        autoplay: {
            delay: 1500,
            disableOnInteraction: false,
        },
        speed: 500,
        allowTouchMove: false,
        slidesPerView: 6,
        centeredSlides: true,
        spaceBetween: 0,
        modules: [Autoplay]
    });
});